import * as React from 'react';
import {Datagrid, List, ListProps, EditButton, ReferenceField, NumberField} from 'react-admin';
import {Fragment, ReactElement} from 'react';
import { Route } from 'react-router';
import PriceMatrixFilter from "./PriceMatrixFilter";
import PriceMatrixCreate from "./PriceMatrixCreate";
import PriceMatrixEdit from "./PriceMatrixEdit";
import SideDrawer from "../../../components/list/SideDrawer";
import TextField from "../../../components/list/TextField";
import ListActions from "../../../components/list/ListActions";


const PriceMatrixList = (props: ListProps): ReactElement => {

    return (
        <Fragment>
            <List {...props} filters={<PriceMatrixFilter/>} sort={{field: 'id', order: 'DESC'}} actions={<ListActions/>}>
                <Datagrid>
                    <ReferenceField label={"resources.admin/lod-price-matrix.fields.material"} source="material_id" reference="admin/lod-materials" sortable={false}>
                        <TextField source="name_lt"/>
                    </ReferenceField>
                    <ReferenceField label={"resources.admin/lod-price-matrix.fields.thickness"} source="thickness_id" reference="admin/lod-thickness" sortable={false}>
                        <TextField source="value"/>
                    </ReferenceField>
                    <TextField source="min_signs"/>
                    <TextField source="max_signs"/>
                    <NumberField source="obor_price" options={{ style: 'currency', currency: 'EUR' }} />
                    <NumberField source="obmr_price" options={{ style: 'currency', currency: 'EUR' }} />
                    <NumberField source="mbor_price" options={{ style: 'currency', currency: 'EUR' }} />
                    <NumberField source="mbmr_price" options={{ style: 'currency', currency: 'EUR' }} />
                    <EditButton/>
                </Datagrid>
            </List>
            <Route path={`${props.basePath}/create`}>
                {({ match }) => {
                    return (
                        <SideDrawer open={!!match} basePath={props.basePath??''}>
                            <PriceMatrixCreate {...props} />
                        </SideDrawer>
                    )
                }}
            </Route>
            <Route path={`${props.basePath}/:id`}>
                {({ match }) => {
                    const isMatch = !!(match && match.params && match.params.id !== 'create');
                    return (
                        <SideDrawer open={isMatch} basePath={props.basePath??''}>
                            {isMatch && (
                                <PriceMatrixEdit id={match && isMatch ? match.params.id : undefined}{...props}/>
                            )}
                        </SideDrawer>
                    );
                }}
            </Route>
        </Fragment>
    );
};

export default PriceMatrixList;
